"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
exports.initialState = {
    currentPage: 0,
    pagesCount: 6,
    canGoNext: false,
};
